import { render } from "./ElementComponent.vue?vue&type=template&id=671a4200&scoped=true"
import script from "./ElementComponent.vue?vue&type=script&lang=js"
export * from "./ElementComponent.vue?vue&type=script&lang=js"

import "./ElementComponent.vue?vue&type=style&index=0&id=671a4200&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671a4200"]])

export default __exports__